import { z } from 'zod'
import { withValidate } from 'lib/zod-validate'

export const reminderSchema = withValidate(z.object({
    model_id: z.number().int().nullable().optional(),
    model_name: z.string().min(1, 'Model name is required'),
    type: z.string().min(1, 'Type is required'),
    hall_id: z.number().int().positive('Hall is required'),
    seller_id: z.number().int().nullable().optional(),
    interval: z.number().int().nullable().optional(),
    content: z.string().min(1, 'Content is required'),
    due_at: z.string().min(1, 'Due date is required'),
    expires_at: z.string().nullable().optional(),
}))

export type ReminderRequest = z.infer<typeof reminderSchema>
